import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import ComboDemo from './ComboDemo';
import AutoDemo from './AutoDemo';
import ArrowComboDemo from './ArrowComboDemo';
import SearchBoxDemo from './SearchBoxDemo';
import MulticomboDemo from './MulticomboDemo';

const DropDowns = () => (
	<React.Fragment>
		<ContentHeader title="DropDowns" description="Different types of dropdowns">
		</ContentHeader>
		<ContentBody>
			<Row>
				<Col md={6}>
					<ComboDemo />
				</Col>
				<Col md={6}>
					<AutoDemo />
				</Col>
            </Row>
            <Row>
                <Col md={6}>
                    <ArrowComboDemo />
                </Col>
                <Col md={6}>
                   <SearchBoxDemo />
                </Col>
			</Row>
			<Row>
				<Col md={6}>
					<MulticomboDemo />
				</Col>
				<Col md={6}>
				</Col>
			</Row>
		</ContentBody>
	</React.Fragment>
)

export default DropDowns;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/DropDowns/index.js